import { ChevronDownIcon } from '@heroicons/react/24/outline'
import { useMediaQuery } from '@mantine/hooks'
import dayjs from 'dayjs'
import {
  internshipDesc,
  pointDesc,
  curriculumSlideList,
  curriculumDetailList,
  projectSlideList,
  projectOutputList,
  prepareFirstDetailList,
  prepareSecondDetailList,
  programDetailList,
  reviewList,
  benefitSlideList,
  bootCampFaqList,
  bootCampFaqTabList,
  EduScheduleList,
} from '../../../../constants/kdt-aos-4th'
import Link from 'next/link'
import ReactPlayer from 'react-player'
import { useMemo, useState } from 'react'
import { useCopyUrlShare } from 'shared/hooks/useCopyUrlShare'
import CurriculumAccordion from './CurriculumAccordion'
import CurriculumTab from './CurriculumTab'
import ProgramAccordion from './ProgramAccordion'
import ProgramTab from './ProgramTab'
import {
  CurriculumSliderItem,
  ProjectSliderItem,
  ProgramSliderItem,
  ProjectOutputSliderItem,
  ReviewSliderItem,
  BenefitSliderItem,
} from './SliderItem'
import styles from './kdt-aos-4th.module.scss'
import { schoolNavList, ScrollNav } from './ScrollNav'

const AOSKlass4th = () => {
  const isMobile = useMediaQuery('(max-width: 1023px)')
  const [faqTab, setFaqTab] = useState('apply')
  const allFaqs = [
    ...bootCampFaqList.apply,
    ...bootCampFaqList.nebeka,
    ...bootCampFaqList.employment,
    ...bootCampFaqList.edu,
    ...bootCampFaqList.benefit,
    ...bootCampFaqList.etc,
  ]
  const faqList = faqTab === 'all' ? allFaqs : bootCampFaqList[faqTab]
  const onClickFaqTab = (value: string) => {
    setFaqTab(value)
  }
  const earlySessionDate = new Date('2025-02-04 18:00')
  const isAfterEarlySessionDate = useMemo(() => dayjs().isAfter(earlySessionDate), [])
  const { copyUrlShare } = useCopyUrlShare()

  return (
    <div>
      {/* Section1_키비주얼 */}
      <section className="bg-black">
        <div className={`${styles.section1_kv} relative w-full`}>
          <div className="absolute left-0 top-0 w-full">
            <img
              className="relative z-10 w-full object-cover"
              src={`https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section1_kv_new_after_${
                isMobile ? 'm' : 'pc'
              }.png`}
              alt="[멋쟁이사자처럼] 기업이 선호하는 인재로 거듭나는 유일한 Android 교육 - Android 개발 부트캠프"
            />
          </div>
        </div>
      </section>

      {/* Section2_핵심포인트 */}
      <section className="bg-gray-900 py-10 lg:pb-[120px] lg:pt-20">
        <div className="mx-auto w-full max-w-7xl px-4 lg:px-6">
          <ul
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="flex w-full flex-col gap-y-3 lg:flex-row lg:flex-wrap lg:gap-x-6 lg:gap-y-5"
          >
            <li className="flex w-full flex-row items-center gap-3 rounded-lg bg-trueGray-800 px-3 py-4 lg:w-[calc(50%-12px)] lg:gap-[34px] lg:p-6">
              <img
                className="h-[73px] w-[73px] rounded-lg object-cover lg:h-[88px] lg:w-[88px]"
                src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section2_icon2.png"
                alt="-"
              />
              <p className="flex-1 text-base font-semibold leading-normal text-white lg:text-xl lg:font-bold lg:leading-tight">
                기업이 원하는 핵심 스킬로
                <br />
                구성된 특화 커리큘럼
              </p>
            </li>
            <li className="flex w-full flex-row items-center gap-3 rounded-lg bg-trueGray-800 px-3 py-4 lg:w-[calc(50%-12px)] lg:gap-[34px] lg:p-6">
              <img
                className="h-[73px] w-[73px] rounded-lg object-cover lg:h-[88px] lg:w-[88px]"
                src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section2_icon4.png"
                alt="-"
              />
              <p className="flex-1 text-base font-semibold leading-normal text-white lg:text-xl lg:font-bold lg:leading-tight">
                빠른 취업 성공을 위한
                <br />
                단독 취업 지원 혜택
              </p>
            </li>
            <li className="flex w-full flex-row items-center gap-3 rounded-lg bg-trueGray-800 px-3 py-4 lg:w-[calc(50%-12px)] lg:gap-[34px] lg:p-6">
              <img
                className="h-[73px] w-[73px] rounded-lg object-cover lg:h-[88px] lg:w-[88px]"
                src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section2_icon1.png"
                alt="-"
              />
              <p className="flex-1 text-base font-semibold leading-normal text-white lg:text-xl lg:font-bold lg:leading-tight">
                4개의 프로젝트 경험으로
                <br />
                경쟁력있는 포트폴리오 완성
              </p>
            </li>
            <li className="flex w-full flex-row items-center gap-3 rounded-lg bg-trueGray-800 px-3 py-4 lg:w-[calc(50%-12px)] lg:gap-[34px] lg:p-6">
              <img
                className="h-[73px] w-[73px] rounded-lg object-cover lg:h-[88px] lg:w-[88px]"
                src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section2_icon3.png"
                alt="-"
              />
              <p className="flex-1 text-base font-semibold leading-normal text-white lg:text-xl lg:font-bold lg:leading-tight">
                Android 1티어 강사님과
                <br />
                이론/실무 마스터
              </p>
            </li>
          </ul>
        </div>
      </section>

      {/* Section3_모집정보*/}
      <section className="bg-trueGray-800 pb-10 pt-[60px] lg:py-20">
        <div className="mx-auto w-full max-w-7xl px-4 lg:px-6">
          <ul
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className="flex w-full flex-col"
          >
            <li className="flex w-full flex-row items-start gap-[45px] border-b border-[#3D3D3D] py-3 lg:items-center lg:gap-[231px] lg:px-0 lg:pb-4 lg:pt-0">
              <h6 className="flex flex-row items-center justify-start gap-3 text-sm font-semibold text-white lg:w-[185px] lg:gap-4 lg:text-base">
                <img
                  className="h-5 w-5 lg:h-6 lg:w-6"
                  src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section3_icon1.png"
                  alt="-"
                />
                지원기간
              </h6>
              <p className="flex-1 text-sm text-label-assistive lg:text-base">
                25.1.15 오후 2시 ~ <br className="block lg:hidden" />
                25.3.10 오후 11시
              </p>
            </li>
            <li className="flex w-full flex-row flex-wrap items-center gap-x-[45px] gap-y-3.5 border-b border-[#3D3D3D] pb-6 pt-3 lg:flex-nowrap lg:gap-x-[231px] lg:border-0 lg:px-0 lg:pb-0 lg:pt-4">
              <h6 className="flex flex-row items-center justify-start gap-3 text-sm font-semibold text-white lg:w-[185px] lg:gap-4 lg:text-base">
                <img
                  className="h-5 w-5 lg:h-6 lg:w-6"
                  src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section3_icon2.png"
                  alt="-"
                />
                수강기간
              </h6>
              <p className="flex-1 text-sm text-label-assistive lg:text-base">
                25.3.12 ~ 25.9.2 (일 8시간 교육)
              </p>
            </li>
          </ul>
          <ul
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="900"
            className="mt-6 flex w-full flex-col gap-3 lg:mt-8 lg:flex-row lg:gap-4"
          >
            <li className="flex w-full flex-row items-center justify-center rounded-lg border border-yellow-450 bg-[rgba(255,119,16,0.1)] py-4 lg:w-auto lg:flex-1 lg:justify-start lg:px-6 lg:py-5">
              <h6 className="text-sm font-bold text-white lg:text-left lg:text-lg">
                내일배움카드로 교육비 무료
              </h6>
            </li>
            <li className="flex w-full flex-row items-center justify-center rounded-lg border border-yellow-450 bg-[rgba(255,119,16,0.1)] py-4 lg:w-auto lg:flex-1 lg:justify-start lg:px-6 lg:py-5">
              <h6 className="text-sm font-bold text-white lg:text-left lg:text-lg">
                매월 최대 81만원의 지원금 신청 가능
              </h6>
            </li>
          </ul>
        </div>
      </section>

      <ScrollNav schoolNavList={schoolNavList} />

      {/* 2025.02.13 추가영역 */}
      <section className="bg-gray-900 pb-24 pt-20 lg:pb-36 lg:pt-[120px]">
        <div className="mx-auto w-full max-w-7xl px-4 lg:px-6">
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="mb-10 flex flex-col items-center justify-center gap-2 lg:mb-16 lg:gap-[18px]"
          >
            <p className="text-sm font-bold text-yellow-450 lg:text-lg">
              앱 개발자 취업은 ‘이것'이 중요해요!
            </p>
            <h4 className="text-center text-xl font-bold leading-snug text-white lg:text-4xl lg:leading-[1.4]">
              Android 개발자 스킬,
              <br />
              Flutter만으로는 부족한 이유
            </h4>
            <p className="text-center text-sm text-label-assistive lg:text-lg">
              Flutter는 크로스 플랫폼 앱 개발이 가능하다는 <br className="block lg:hidden" />
              장점이 있지만, <br className="hidden lg:block" />
              최신 OS 도입에 제약이 있는 <br className="block lg:hidden" />
              많은 기업들에서는 네이티브 언어인 Java와 Kotlin을
              <br />
              모두 다룰 수 있는 앱 개발자를 선호해요.
            </p>
          </div>
        </div>
        <div
          data-aos-once="true"
          data-aos="fade-up"
          data-aos-easing="ease"
          data-aos-duration="800"
          data-aos-delay="600"
          className="mx-auto w-full max-w-7xl lg:px-6"
        >
          <img
            className="w-full object-cover"
            src={`https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section_add_img_${
              isMobile ? 'm' : 'pc'
            }.png`}
            alt="-"
          />
        </div>
      </section>

      {/* Section5_핵심포인트 */}
      <section className="bg-trueGray-800 pb-24 pt-20 lg:pb-40 lg:pt-36">
        <div className="mx-auto w-full max-w-7xl px-4 lg:px-6">
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="mb-10 flex flex-col items-center justify-center gap-2 lg:mb-16 lg:gap-[18px]"
          >
            <p className="text-sm font-bold text-yellow-450 lg:text-lg">취업 경쟁력</p>
            <h4 className="text-center text-xl font-bold leading-snug text-white lg:text-4xl lg:leading-[1.4]">
              기업이 선호하는 인재로 거듭나는
              <br />
              유일한 Android 교육
            </h4>
            <p className="text-center text-sm leading-normal text-label-assistive lg:text-lg">
              Java와 Kotlin으로 기본기를 다지고 Flutter 역량까지 길러
              <br />
              기업이 원하는 핵심 역량을 키워 포트폴리오를 강화해요.
            </p>
          </div>
          <ul
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className="flex flex-col gap-3 lg:flex-row lg:gap-6"
          >
            {pointDesc.map(point => (
              <li
                className="flex w-full flex-col gap-2 overflow-hidden rounded-lg bg-[#303030] p-4 lg:h-[212px] lg:flex-1 lg:items-center lg:gap-6 lg:px-6 lg:py-[42.5px]"
                key={point.step}
              >
                <div className="flex w-full flex-1 flex-col gap-3 lg:gap-2.5">
                  <p className="flex h-[18px] max-w-fit flex-col items-center justify-center rounded bg-[rgba(255,119,16,0.1)] px-1.5 text-xs font-bold text-yellow-450">
                    {point.step}
                  </p>
                  <p className="whitespace-pre-wrap text-base font-bold leading-normal text-white lg:text-lg">
                    {point.title}
                  </p>
                </div>
                <div className="flex w-full flex-col">
                  <p
                    className={`${styles.section5_text_dot} w-full whitespace-pre-wrap text-sm font-medium leading-normal text-label-alternative lg:text-base`}
                  >
                    {point.desc1}
                  </p>
                  <p
                    className={`${styles.section5_text_dot} w-full whitespace-pre-wrap text-sm font-medium leading-normal text-label-alternative lg:text-base`}
                  >
                    {point.desc2}
                  </p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* Section6_커리큘럼 */}
      <section id="curriculum" className="bg-gray-900 py-20 lg:pb-60 lg:pt-36">
        <div className="mx-auto w-full max-w-7xl px-4 lg:px-6">
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="mb-10 flex flex-col items-center justify-center gap-2 lg:mb-16 lg:gap-[18px]"
          >
            <p className="text-sm font-bold text-yellow-450 lg:text-lg">커리큘럼</p>
            <h4 className="text-center text-xl font-bold leading-snug text-white lg:text-4xl lg:leading-[1.4]">
              취업에 필요한 핵심 스킬을 모두 담은
              <br />
              Android 특화 커리큘럼
            </h4>
            <p className="text-center text-sm leading-normal text-label-assistive lg:text-lg">
              최신 채용 트렌드를 반영한 커리큘럼으로
              <br />
              안드로이드 개발자 취업에 완벽 대비해요.
            </p>
          </div>

          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className={`${styles.section6_slider} mb-[103px] overflow-hidden lg:mb-16 lg:rounded-lg lg:bg-trueGray-800 lg:px-6 lg:py-10`}
          >
            <div className="lg:px-16">
              <CurriculumSliderItem contents={curriculumSlideList} />
            </div>
          </div>
        </div>

        <div className="mx-auto w-full max-w-7xl lg:px-6">
          <h5
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className="mb-10 text-center text-base font-semibold text-label-assistive lg:mb-16 lg:text-2xl lg:font-bold"
          >
            세부 커리큘럼
          </h5>

          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className={`${styles.curriculum_accordion_wrap} hidden flex-row overflow-hidden rounded-lg bg-trueGray-800 lg:flex`}
          >
            <CurriculumTab curriculumDetailList={curriculumDetailList} />
          </div>
          <ul
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className={`${styles.curriculum_accordion_wrap} flex flex-col overflow-hidden lg:hidden`}
          >
            {curriculumDetailList.map((project, idx) => (
              <CurriculumAccordion contents={project} key={project.title} idx={idx} />
            ))}
          </ul>

          <p className="mt-10 text-center text-xs text-label-assistive lg:mt-[102px] lg:text-base">
            * 교육생 훈련 상황 및 회사 사정에 따라 세부 일정이 <br className="block lg:hidden" />
            변동 될 수 있습니다.
          </p>
        </div>
      </section>

      {/* Section7_프로젝트 */}
      <section id="project" className="bg-strong pb-24 pt-20 lg:pb-40 lg:pt-36">
        <div className="mx-auto w-full max-w-7xl lg:px-6">
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="mb-10 flex flex-col items-center justify-center gap-2 lg:mb-16 lg:gap-[18px]"
          >
            <p className="text-sm font-bold text-yellow-450 lg:text-lg">프로젝트</p>
            <h4 className="text-center text-xl font-bold leading-snug text-label-normal lg:text-4xl lg:leading-[1.4]">
              4번의 실전 프로젝트로
              <br />
              차별화된 포트폴리오를 완성해요
            </h4>
            <p className="text-center text-sm leading-normal text-label-neutral lg:text-lg">
              상상만 하던 앱을 직접 개발하고 배포까지 경험할 수 있는
              <br />
              프로젝트로 6개월 만에 취업 준비 끝!
            </p>
          </div>

          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className={`${styles.section7_slider} overflow-hidden lg:mb-16 lg:rounded-lg lg:border lg:bg-white lg:px-6 lg:py-10`}
          >
            <div className="px-4 lg:px-16">
              <ProjectSliderItem contents={projectSlideList} />
            </div>
          </div>
        </div>
      </section>

      {/* Section8_수료생 결과물 */}
      <section className="bg-[#EBEBEB] pb-24 pt-20 lg:pb-[155px] lg:pt-36">
        <div className="mx-auto w-full max-w-7xl px-4 lg:px-6">
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="mb-10 flex flex-col items-center justify-center gap-2 lg:mb-16 lg:gap-[18px]"
          >
            <p className="text-sm font-bold text-yellow-450 lg:text-lg">수료생 결과물</p>
            <h4 className="text-center text-xl font-bold leading-snug text-label-normal lg:text-4xl lg:leading-[1.4]">
              배포부터 개선까지 경험한
              <br />
              선배들의 앱을 확인해 보세요
            </h4>
          </div>
        </div>
        <div
          data-aos-once="true"
          data-aos="fade-up"
          data-aos-easing="ease"
          data-aos-duration="800"
          data-aos-delay="600"
          className={`${styles.section8_slider}`}
        >
          <ProjectOutputSliderItem contents={projectOutputList} />
        </div>
      </section>

      {/* Section9_해커톤 */}
      <section className={`${styles.section9_bg} bg-[#FFF9F5] py-20 lg:pb-40 lg:pt-36`}>
        <div className="mx-auto w-full max-w-7xl px-4 lg:px-6">
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="mb-10 flex flex-col items-center justify-center gap-2 lg:mb-16 lg:gap-[18px]"
          >
            <p className="text-sm font-bold text-yellow-450 lg:text-lg">오프라인 해커톤</p>
            <h4 className="text-center text-xl font-bold leading-snug text-label-normal lg:text-4xl lg:leading-[1.4]">
              현직자의 실시간 피드백으로 성장하는
              <br />
              “멋쟁이사자처럼 해커톤”
            </h4>
          </div>
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className="flex flex-col items-center justify-center overflow-hidden rounded-lg bg-white lg:flex-row lg:gap-6"
          >
            <img
              className="w-full max-w-[604px] object-cover lg:w-1/2"
              src={`https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section9_img1_${
                isMobile ? 'm' : 'pc'
              }.png`}
              alt="-"
            />
            <div className="flex w-full flex-col gap-[14px] p-4 lg:mr-12 lg:w-auto lg:flex-1 lg:gap-4 lg:p-6">
              <h6 className="border-b pb-[14px] text-sm font-bold text-label-normal lg:pb-4 lg:text-base">
                Android 개발 해커톤을 통해 마음 맞는 동료와 교류하고{' '}
                <br className="hidden lg:block" />
                현직자의 실시간 피드백으로 개선 경험까지 쌓아요.
              </h6>
              <div className="flex flex-col gap-2 lg:gap-3">
                <p className="text-sm font-bold leading-normal text-label-neutral lg:text-lg">
                  주요 사용 스킬
                </p>
                <ul className="flex flex-col gap-1 lg:gap-0.5">
                  <li
                    className={`${styles.section9_dot} text-sm leading-normal text-label-neutral lg:text-base`}
                  >
                    Android Studio, Kotlin, Java
                  </li>
                  <li
                    className={`${styles.section9_dot} text-sm leading-normal text-label-neutral lg:text-base`}
                  >
                    Android Jetpack (ViewModel, LiveData, Room 등)
                  </li>
                  <li
                    className={`${styles.section9_dot} text-sm leading-normal text-label-neutral lg:text-base`}
                  >
                    Firebase 연동
                  </li>
                  <li
                    className={`${styles.section9_dot} text-sm leading-normal text-label-neutral lg:text-base`}
                  >
                    Retrofit 네트워킹
                  </li>
                  <li
                    className={`${styles.section9_dot} text-sm leading-normal text-label-neutral lg:text-base`}
                  >
                    Compose UI
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className="mt-12 flex flex-col items-center justify-center overflow-hidden rounded-lg bg-white lg:mt-6 lg:flex-row lg:gap-6"
          >
            <img
              className="max-h-[344px] w-full max-w-[604px] object-cover lg:w-1/2"
              src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section9_img2.gif"
              alt="-"
            />
            <div className="flex w-full flex-col gap-2 p-4 lg:mr-12 lg:w-auto lg:flex-1 lg:gap-4 lg:p-6">
              <h6 className="border-b pb-[14px] text-sm font-bold text-label-normal lg:pb-4 lg:text-base">
                동료와 함께 아이디어 도출부터 서비스 구현까지 개발 그 이상의 성취를 경험하세요
              </h6>
              <div className="flex flex-col gap-2 lg:gap-3">
                <p className="text-sm font-bold leading-normal text-label-neutral lg:text-lg">
                  주요 향상 역량
                </p>
                <ul className="flex flex-col gap-1 lg:gap-0.5">
                  <li
                    className={`${styles.section9_dot} text-sm leading-normal text-label-neutral lg:text-base`}
                  >
                    서비스 기획 및 UI/UX 설계 능력
                    <br />- 사용자 중심의 앱 설계 경험
                  </li>
                  <li
                    className={`${styles.section9_dot} text-sm leading-normal text-label-neutral lg:text-base`}
                  >
                    최신 안드로이드 개발 트렌드 이해
                    <br />- AAC와 Compose를 활용한 개발 방식 습득
                  </li>
                  <li
                    className={`${styles.section9_dot} text-sm leading-normal text-label-neutral lg:text-base`}
                  >
                    상태 관리 및 데이터 처리
                    <br />- 실시간 데이터 관리와 복잡한 상태 제어 능력 강화
                  </li>
                  <li
                    className={`${styles.section9_dot} text-sm leading-normal text-label-neutral lg:text-base`}
                  >
                    팀 프로젝트 협업 능력
                    <br />- 동료와의 협업을 통해 완성도 높은 프로젝트 개발
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className="mt-12 flex flex-col items-start justify-center rounded-lg bg-white p-4 lg:mt-16 lg:p-6"
          >
            <div className="mb-6 flex flex-1 flex-col">
              <h6 className="text-lg font-bold text-label-normal lg:text-2xl">해커톤 진행방식</h6>
            </div>
            <div className="flex w-full flex-col lg:flex-row">
              <div className="flex h-32 flex-row-reverse gap-4 lg:flex-1 lg:flex-col lg:gap-6">
                <div className="flex w-full flex-row-reverse items-center justify-center lg:flex-col">
                  <div className="flex h-full w-full flex-col items-center justify-center gap-1 rounded bg-[#FFF3EB] lg:h-[170px] lg:justify-start lg:gap-2.5 lg:pt-4">
                    <p className="text-sm font-bold text-yellow-450">STEP 1</p>
                    <p className="text-center text-base leading-normal text-label-neutral lg:text-lg">
                      팀 빌딩 및<br />
                      프로젝트 주제 선정
                    </p>
                  </div>
                  <img
                    className="-mr-[3px] h-4 w-5 rotate-90 transform object-contain lg:-mt-[1px] lg:mr-0 lg:rotate-0"
                    src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-4th/section9_img_arrow.png"
                    alt="-"
                  />
                </div>
                <div className="flex h-full w-4 flex-col items-center justify-center lg:h-4 lg:w-full lg:flex-row">
                  <div className="h-full w-0.5 bg-gradient-to-b from-white to-yellow-450 lg:h-0.5 lg:w-full lg:bg-gradient-to-r"></div>
                  <div className="h-3 w-3 shrink-0 rounded-full bg-yellow-450 lg:h-4 lg:w-4"></div>
                  <div className="h-full w-0.5 bg-yellow-450 lg:h-0.5 lg:w-full"></div>
                </div>
              </div>
              <div className="flex h-4 flex-row-reverse justify-between gap-4 lg:h-full lg:w-4 lg:flex-col lg:gap-6">
                <div className="flex h-full w-full flex-row-reverse items-center justify-center lg:h-[186px] lg:flex-col"></div>
                <div className="flex h-full w-4 flex-col items-center justify-center lg:h-4 lg:w-full lg:flex-row">
                  <div className="h-full w-0.5 bg-yellow-450 lg:h-0.5 lg:w-full"></div>
                </div>
              </div>
              <div className="flex h-32 flex-row-reverse gap-4 lg:flex-1 lg:flex-col lg:gap-6">
                <div className="flex w-full flex-row-reverse items-center justify-center lg:flex-col">
                  <div className="flex h-full w-full flex-col items-center justify-center gap-1 rounded bg-[#FFF3EB] lg:h-[170px] lg:justify-start lg:gap-2.5 lg:pt-4">
                    <p className="text-sm font-bold text-yellow-450">STEP 2</p>
                    <p className="text-center text-base leading-normal text-label-neutral lg:text-lg">
                      서비스 기획 및 앱 <br className="hidden lg:block" />
                      구조 설계,
                      <br />
                      개발 환경 구축
                    </p>
                  </div>
                  <img
                    className="-mr-[3px] h-4 w-5 rotate-90 transform object-contain lg:-mt-[1px] lg:mr-0 lg:rotate-0"
                    src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-4th/section9_img_arrow.png"
                    alt="-"
                  />
                </div>
                <div className="flex h-full w-4 flex-col items-center justify-center lg:h-4 lg:w-full lg:flex-row">
                  <div className="h-full w-0.5 bg-yellow-450 lg:h-0.5 lg:w-full"></div>
                  <div className="h-3 w-3 shrink-0 rounded-full bg-yellow-450 lg:h-4 lg:w-4"></div>
                  <div className="h-full w-0.5 bg-yellow-450 lg:h-0.5 lg:w-full"></div>
                </div>
              </div>
              <div className="flex h-4 flex-row-reverse justify-between gap-4 lg:h-full lg:w-4 lg:flex-col lg:gap-6">
                <div className="flex h-full w-full flex-row-reverse items-center justify-center lg:h-[186px] lg:flex-col"></div>
                <div className="flex h-full w-4 flex-col items-center justify-center lg:h-4 lg:w-full lg:flex-row">
                  <div className="h-full w-0.5 bg-yellow-450 lg:h-0.5 lg:w-full"></div>
                </div>
              </div>
              <div className="flex h-32 flex-row-reverse gap-4 lg:flex-1 lg:flex-col lg:gap-6">
                <div className="flex w-full flex-row-reverse items-center justify-center lg:flex-col">
                  <div className="flex h-full w-full flex-col items-center justify-center gap-1 rounded bg-[#FFF3EB] lg:h-[170px] lg:justify-start lg:gap-2.5 lg:pt-4">
                    <p className="text-sm font-bold text-yellow-450">STEP 3</p>
                    <p className="text-center text-base leading-normal text-label-neutral lg:text-lg">
                      GitHub를 활용한 <br className="hidden lg:block" />
                      협업 규칙 설정 <br className="block lg:hidden" />및{' '}
                      <br className="hidden lg:block" />
                      버전 관리
                    </p>
                  </div>
                  <img
                    className="-mr-[3px] h-4 w-5 rotate-90 transform object-contain lg:-mt-[1px] lg:mr-0 lg:rotate-0"
                    src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-4th/section9_img_arrow.png"
                    alt="-"
                  />
                </div>
                <div className="flex h-full w-4 flex-col items-center justify-center lg:h-4 lg:w-full lg:flex-row">
                  <div className="h-full w-0.5 bg-yellow-450 lg:h-0.5 lg:w-full"></div>
                  <div className="h-3 w-3 shrink-0 rounded-full bg-yellow-450 lg:h-4 lg:w-4"></div>
                  <div className="h-full w-0.5 bg-yellow-450 lg:h-0.5 lg:w-full"></div>
                </div>
              </div>
              <div className="flex h-4 flex-row-reverse justify-between gap-4 lg:h-full lg:w-4 lg:flex-col lg:gap-6">
                <div className="flex h-full w-full flex-row-reverse items-center justify-center lg:h-[186px] lg:flex-col"></div>
                <div className="flex h-full w-4 flex-col items-center justify-center lg:h-4 lg:w-full lg:flex-row">
                  <div className="h-full w-0.5 bg-yellow-450 lg:h-0.5 lg:w-full"></div>
                </div>
              </div>
              <div className="flex h-32 flex-row-reverse gap-4 lg:flex-1 lg:flex-col lg:gap-6">
                <div className="flex w-full flex-row-reverse items-center justify-center lg:flex-col">
                  <div className="flex h-full w-full flex-col items-center justify-center gap-1 rounded bg-[#FFF3EB] lg:h-[170px] lg:justify-start lg:gap-2.5 lg:pt-4">
                    <p className="text-sm font-bold text-yellow-450">STEP 4</p>
                    <p className="text-center text-base leading-normal text-label-neutral lg:text-lg">
                      강사님의 <br className="hidden lg:block" />
                      진행 상황 점검 및<br />
                      피드백
                    </p>
                  </div>
                  <img
                    className="-mr-[3px] h-4 w-5 rotate-90 transform object-contain lg:-mt-[1px] lg:mr-0 lg:rotate-0"
                    src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-4th/section9_img_arrow.png"
                    alt="-"
                  />
                </div>
                <div className="flex h-full w-4 flex-col items-center justify-center lg:h-4 lg:w-full lg:flex-row">
                  <div className="h-full w-0.5 bg-yellow-450 lg:h-0.5 lg:w-full"></div>
                  <div className="h-3 w-3 shrink-0 rounded-full bg-yellow-450 lg:h-4 lg:w-4"></div>
                  <div className="h-full w-0.5 bg-yellow-450 lg:h-0.5 lg:w-full"></div>
                </div>
              </div>
              <div className="flex h-4 flex-row-reverse justify-between gap-4 lg:h-full lg:w-4 lg:flex-col lg:gap-6">
                <div className="flex h-full w-full flex-row-reverse items-center justify-center lg:h-[186px] lg:flex-col"></div>
                <div className="flex h-full w-4 flex-col items-center justify-center lg:h-4 lg:w-full lg:flex-row">
                  <div className="h-full w-0.5 bg-yellow-450 lg:h-0.5 lg:w-full"></div>
                </div>
              </div>
              <div className="flex h-32 flex-row-reverse gap-4 lg:flex-1 lg:flex-col lg:gap-6">
                <div className="flex w-full flex-row-reverse items-center justify-center lg:flex-col">
                  <div className="flex h-full w-full flex-col items-center justify-center gap-1 rounded bg-[#FFF3EB] lg:h-[170px] lg:justify-start lg:gap-2.5 lg:pt-4">
                    <p className="text-sm font-bold text-yellow-450">STEP 5</p>
                    <p className="text-center text-base leading-normal text-label-neutral lg:text-lg">
                      주요 기능 구현 및<br />
                      테스트
                    </p>
                  </div>
                  <img
                    className="-mr-[3px] h-4 w-5 rotate-90 transform object-contain lg:-mt-[1px] lg:mr-0 lg:rotate-0"
                    src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-4th/section9_img_arrow.png"
                    alt="-"
                  />
                </div>
                <div className="flex h-full w-4 flex-col items-center justify-center lg:h-4 lg:w-full lg:flex-row">
                  <div className="h-full w-0.5 bg-yellow-450 lg:h-0.5 lg:w-full"></div>
                  <div className="h-3 w-3 shrink-0 rounded-full bg-yellow-450 lg:h-4 lg:w-4"></div>
                  <div className="h-full w-0.5 bg-yellow-450 lg:h-0.5 lg:w-full"></div>
                </div>
              </div>
              <div className="flex h-4 flex-row-reverse justify-between gap-4 lg:h-full lg:w-4 lg:flex-col lg:gap-6">
                <div className="flex h-full w-full flex-row-reverse items-center justify-center lg:h-[186px] lg:flex-col"></div>
                <div className="flex h-full w-4 flex-col items-center justify-center lg:h-4 lg:w-full lg:flex-row">
                  <div className="h-full w-0.5 bg-yellow-450 lg:h-0.5 lg:w-full"></div>
                </div>
              </div>
              <div className="flex h-32 flex-row-reverse gap-4 lg:flex-1 lg:flex-col lg:gap-6">
                <div className="flex w-full flex-row-reverse items-center justify-center lg:flex-col">
                  <div className="flex h-full w-full flex-col items-center justify-center gap-1 rounded bg-[#FFF3EB] lg:h-[170px] lg:justify-start lg:gap-2.5 lg:pt-4">
                    <p className="text-sm font-bold text-yellow-450">STEP 6</p>
                    <p className="text-center text-base leading-normal text-label-neutral lg:text-lg">
                      오프라인 데모데이를 <br className="hidden lg:block" />
                      통한 현직자 <br className="block lg:hidden" />
                      피드백 <br className="hidden lg:block" />및 추가 개선점 도출
                    </p>
                  </div>
                  <img
                    className="-mr-[3px] h-4 w-5 rotate-90 transform object-contain lg:-mt-[1px] lg:mr-0 lg:rotate-0"
                    src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-4th/section9_img_arrow.png"
                    alt="-"
                  />
                </div>
                <div className="flex h-full w-4 flex-col items-center justify-center lg:h-4 lg:w-full lg:flex-row">
                  <div className="h-full w-0.5 bg-yellow-450 lg:h-0.5 lg:w-full"></div>
                  <div className="h-3 w-3 shrink-0 rounded-full bg-yellow-450 lg:h-4 lg:w-4"></div>
                  <div className="h-full w-0.5 bg-gradient-to-t from-white to-yellow-450 lg:h-0.5 lg:w-full lg:bg-gradient-to-l"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section10_강사진 */}
      <section id="teacher" className="bg-gray-900 py-20 lg:pb-[133px] lg:pt-36">
        <div className="mx-auto w-full max-w-7xl px-4 lg:px-6">
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="mb-10 flex flex-col items-center justify-center gap-2 lg:mb-16 lg:gap-[18px]"
          >
            <p className="text-sm font-bold text-yellow-450 lg:text-lg">강사진</p>
            <h4 className="text-center text-xl font-bold leading-snug text-white lg:text-4xl lg:leading-[1.4]">
              앱 개발 이론/실무를 마스터하고
              <br />
              취업까지 이끌어 줄 강사진
            </h4>
            <p className="text-center text-sm leading-normal text-label-assistive lg:text-lg">
              안드로이드 개발 서적 1위 저자 강성윤 강사님의 <br className="block lg:hidden" />
              깊이 있는 이론 강의와, <br className="hidden lg:block" />
              현직 개발자 <br className="block lg:hidden" />
              김갑석 강사님의 실전 노하우로 A부터 Z까지 완벽 마스터!
            </p>
          </div>

          <ul
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className="mt-3 flex w-full flex-col gap-10 lg:mt-7 lg:flex-row lg:items-stretch lg:gap-6"
          >
            <li className="flex w-full flex-col overflow-hidden rounded-lg bg-trueGray-800 p-4 lg:w-auto lg:flex-1 lg:px-6 lg:py-5">
              <div className="flex flex-row-reverse items-center gap-6 overflow-hidden lg:flex-row">
                <div className="h-20 w-20 shrink-0 overflow-hidden rounded lg:h-[120px] lg:w-[120px]">
                  <img
                    className="h-full w-full object-cover"
                    src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section10_teacher_img1.png"
                    alt="강성윤 강사님 사진"
                  />
                </div>
                <div className="flex w-full flex-1 flex-col gap-0.5">
                  <p className="text-sm font-bold text-yellow-450">이론 마스터</p>
                  <p className="text-xl font-bold text-white lg:text-2xl">강성윤 강사님</p>
                </div>
              </div>

              <hr className="mt-4 w-full border border-[#737373] lg:mt-6 lg:border-[#3D3D3D]" />

              <dl className="mt-4 flex flex-col gap-0.5 lg:mt-6 lg:gap-1">
                <dt className="text-sm font-bold text-white lg:font-semibold">경력 사항</dt>
                <dd className="flex flex-col gap-0.5 lg:gap-1">
                  <p
                    className={`${styles.teacher_desc_dot} text-sm text-white lg:text-label-assistive`}
                  >
                    멀티캠퍼스 / 강의 (전임강사) / 24년
                  </p>
                  <p
                    className={`${styles.teacher_desc_dot} text-sm text-white lg:text-label-assistive`}
                  >
                    모티즌 소프트 / 소프트웨어 개발 (팀장) / 8년
                  </p>
                </dd>
                <dt className="text-sm font-bold text-white lg:font-semibold">집필 이력</dt>
                <dd className="flex flex-col gap-0.5 lg:gap-1">
                  <p
                    className={`${styles.teacher_desc_dot} text-sm text-white lg:text-label-assistive`}
                  >
                    Do it 깡샘의 플러터 & 다트 프로그래밍
                  </p>
                  <p
                    className={`${styles.teacher_desc_dot} text-sm text-white lg:text-label-assistive`}
                  >
                    Do it 깡샘의 안드로이드 프로그래밍 with Kotlin
                  </p>
                </dd>
                <dt className="text-sm font-bold text-white lg:font-semibold">강의 이력</dt>
                <dd className="flex flex-col gap-0.5 lg:gap-1">
                  <p
                    className={`${styles.teacher_desc_dot} text-sm text-white lg:text-label-assistive`}
                  >
                    직무전환교육 (Front, Back end, Mobile) / KB
                  </p>
                  <p
                    className={`${styles.teacher_desc_dot} text-sm text-white lg:text-label-assistive`}
                  >
                    모바일 역량 강화 교육 / KB, 쿠팡
                  </p>
                  <p
                    className={`${styles.teacher_desc_dot} text-sm text-white lg:text-label-assistive`}
                  >
                    Android App 개발, Flutter / 멀티캠퍼스 (재직자교육)
                  </p>
                </dd>
              </dl>

              <div className="mt-4 flex flex-col gap-1 rounded bg-alternative p-4 lg:mt-6 lg:min-h-[162px]">
                <p className="text-sm font-bold text-label-normal">강사님 한마디</p>
                <p className="text-sm leading-normal text-label-neutral">
                  안드로이드 앱 개발은 기술적 격변기를 지나고 있습니다. 자바에서 코틀린으로, 뷰에서
                  Compose로, RxJava 에서 코루틴으로, 네이티브에서 플러터로 전환 했거나 전환을
                  시도하고 있는 시기인 만큼 준비된 개발자에게는 분명 기회의 시간이 될 것이라
                  확신합니다!
                </p>
              </div>
            </li>

            <li className="flex w-full flex-col items-center justify-center overflow-hidden rounded-lg bg-trueGray-800 lg:mt-6 lg:hidden lg:flex-row lg:border lg:border-yellow-450">
              <img
                className="relative z-10 w-full max-w-[603px] object-cover lg:w-1/2"
                src={`https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section10_book_${
                  isMobile ? 'm' : 'pc'
                }.png`}
                alt="Do it! 깡샘의 안드로이드 앱 프로그래밍 with 코틀린 책 표지 이미지"
              />
              <div className="w-full px-4 py-4 lg:w-auto lg:flex-1 lg:px-12 lg:py-0">
                <h6 className="mb-3 text-lg font-bold text-white lg:border-b lg:border-[#A3A3A3] lg:pb-3 lg:text-2xl">
                  안드로이드 분야 1위 도서 무료 제공!
                </h6>
                <p className="mb-3 border-b border-[#A3A3A3] pb-3 text-base text-white lg:text-lg">
                  강성윤 강사님의 집필 교재를 4기 한정으로
                  <br />
                  무상 지원해요
                </p>
                <p
                  className={`${styles.section10_bottom_dot} text-sm leading-normal text-label-assistive lg:text-base`}
                >
                  &#60;Do it! 깡샘의 안드로이드 앱 프로그래밍 with 코틀린&#62;
                </p>
              </div>
            </li>

            <li className="flex w-full flex-col overflow-hidden rounded-lg bg-trueGray-800 p-4 lg:w-auto lg:flex-1 lg:px-6 lg:py-5">
              <div className="flex flex-row-reverse items-center gap-6 overflow-hidden lg:flex-row">
                <div className="h-20 w-20 shrink-0 overflow-hidden rounded lg:h-[120px] lg:w-[120px]">
                  <img
                    className="h-full w-full object-cover"
                    src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section10_teacher_img2.png"
                    alt="김갑석 강사님 사진"
                  />
                </div>
                <div className="flex w-full flex-1 flex-col gap-0.5">
                  <p className="text-sm font-bold text-yellow-450">실무 마스터</p>
                  <p className="text-xl font-bold text-white lg:text-2xl">김갑석 강사님</p>
                </div>
              </div>

              <hr className="mt-4 w-full border border-[#737373] lg:mt-6 lg:border-[#3D3D3D]" />

              <dl className="mt-4 flex flex-col gap-0.5 lg:mt-6 lg:flex-1 lg:gap-1">
                <dt className="text-sm font-bold text-white lg:font-semibold">경력 사항</dt>
                <dd className="flex flex-col gap-0.5 lg:gap-1">
                  <p
                    className={`${styles.teacher_desc_dot} text-sm text-white lg:text-label-assistive`}
                  >
                    모티즌 소프트 / 소프트웨어 개발 (부장) / 10년
                  </p>
                  <p
                    className={`${styles.teacher_desc_dot} text-sm text-white lg:text-label-assistive`}
                  >
                    모바일리더 / 개발 (선임연구원) / 2년
                  </p>
                </dd>
                <dt className="text-sm font-bold text-white lg:font-semibold">강의 경력</dt>
                <dd className="flex flex-col gap-0.5 lg:gap-1">
                  <p
                    className={`${styles.teacher_desc_dot} text-sm text-white lg:text-label-assistive`}
                  >
                    Android 아키텍쳐 역량강화 교육 / 쿠팡
                  </p>
                </dd>
              </dl>

              <div className="mt-4 flex flex-col gap-1 rounded bg-alternative p-4 lg:mt-6 lg:min-h-[162px]">
                <p className="text-sm font-bold text-label-normal">강사님 한마디</p>
                <p className="text-sm leading-normal text-label-neutral">
                  안드로이드 개발 영역은 초기 자바를 시작으로 여러 개발 언어 및 방법론 등으로
                  지금까지 빠르게 성장을 해왔습니다. 앞으로도 시대의 흐름에 맞춰 많은 변화를 겪으며
                  성장을 이어 갈 것입니다.
                </p>
              </div>
            </li>

            <li className="flex w-full flex-col overflow-hidden rounded-lg bg-trueGray-800 p-4 lg:w-auto lg:flex-1 lg:px-6 lg:py-5">
              <div className="flex w-full flex-col items-center justify-center lg:h-[120px]">
                <p className="w-full text-xl font-bold text-white lg:text-2xl">멘토진</p>
                <p className="mt-3 w-full text-sm font-bold leading-normal text-white lg:hidden">
                  대기업 현직 개발자로 이루어진 멘토진의 멘토링과
                  <br />
                  특강으로 앱 개발자로의 성장에 특별한 재료를 더해요.
                </p>
              </div>

              <hr className="mt-4 w-full border border-[#737373] lg:mt-6 lg:border-[#3D3D3D]" />

              <dl className="mt-4 flex flex-col gap-0.5 lg:mt-6 lg:flex-1 lg:gap-1">
                <dt className="text-sm font-bold text-white lg:font-semibold">Hailey 멘토님</dt>
                <dd className="flex flex-col gap-0.5 lg:gap-1">
                  <p
                    className={`${styles.teacher_desc_dot} text-sm text-white lg:text-label-assistive`}
                  >
                    현) 'K'사 3년차 안드로이드 개발자
                  </p>
                </dd>
                <dt className="text-sm font-bold text-white lg:font-semibold">Bran 멘토님</dt>
                <dd className="flex flex-col gap-0.5 lg:gap-1">
                  <p
                    className={`${styles.teacher_desc_dot} text-sm text-white lg:text-label-assistive`}
                  >
                    현) 'K'사 4년차 안드로이드 개발자
                  </p>
                </dd>
                <dt className="text-sm font-bold text-white lg:font-semibold">Ethan 멘토님</dt>
                <dd className="flex flex-col gap-0.5 lg:gap-1">
                  <p
                    className={`${styles.teacher_desc_dot} text-sm text-white lg:text-label-assistive`}
                  >
                    현) 'N'사 3년차 안드로이드 개발자
                  </p>
                </dd>
              </dl>
              <div className="mt-4 hidden flex-col gap-1 rounded bg-alternative p-4 lg:mt-6 lg:flex lg:min-h-[162px]">
                <p className="text-sm font-bold leading-normal text-label-normal">
                  대기업 현직 개발자로 이루어진 멘토진의 멘토링과 <br />
                  특강으로 앱 개발자로의 성장에 특별한 재료를 더해요.
                </p>
              </div>
            </li>
          </ul>

          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className="mt-10 hidden w-full flex-col items-center justify-center overflow-hidden rounded-lg border border-yellow-450 bg-trueGray-800 lg:mt-6 lg:flex lg:flex-row"
          >
            <img
              className="relative z-10 w-full max-w-[603px] object-cover lg:w-1/2"
              src={`https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section10_book_${
                isMobile ? 'm' : 'pc'
              }.png`}
              alt="Do it! 깡샘의 안드로이드 앱 프로그래밍 with 코틀린 책 표지 이미지"
            />
            <div className="w-full px-4 py-4 lg:w-auto lg:flex-1 lg:px-12 lg:py-0">
              <h6 className="mb-3 text-lg font-bold text-white lg:text-2xl">
                안드로이드 분야 1위 도서 무료 제공!
              </h6>
              <p className="mb-3 text-lg text-white lg:border-b lg:border-[#A3A3A3] lg:pb-3 lg:text-lg">
                강성윤 강사님의 집필 교재를 4기 한정으로 무상 지원해요
              </p>
              <p
                className={`${styles.section10_bottom_dot} text-sm leading-normal text-label-assistive lg:text-base`}
              >
                &#60;Do it! 깡샘의 안드로이드 앱 프로그래밍 with 코틀린&#62;
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Section13_취업지원 */}
      <section id="support" className="bg-[#404040] py-20 lg:pb-40 lg:pt-36">
        <div className="mx-auto w-full max-w-7xl px-4 lg:px-6">
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="mb-10 flex flex-col items-center justify-center gap-2 lg:mb-16 lg:gap-[18px]"
          >
            <p className="text-sm font-bold text-yellow-450 lg:text-lg">취업 지원</p>
            <h4 className="text-center text-xl font-bold leading-snug text-white lg:text-4xl lg:leading-[1.4]">
              취업을 위한 실전 역량을 채우는
              <br />
              단독 취업 지원 혜택
            </h4>
          </div>

          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className="flex flex-col gap-6 lg:mx-auto"
          >
            <div className="flex flex-col items-center justify-center overflow-hidden rounded-lg bg-trueGray-800 lg:flex-row lg:gap-6">
              <img
                className="hidden w-1/2 max-w-[604px] object-cover lg:inline-block"
                src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section13_img1_new_pc.png"
                alt="-"
              />
              <div className="flex flex-1 flex-col lg:mr-6 lg:gap-3 lg:p-6">
                <h6 className="flex flex-row items-center gap-2 p-4 pb-[14px] text-lg font-bold text-white lg:gap-[18px] lg:border-b lg:border-[#A3A3A3] lg:p-0 lg:pb-3 lg:text-2xl">
                  <span className="flex h-6 w-6 items-center justify-center rounded bg-[rgba(255,119,16,0.1)] text-xs font-bold text-yellow-450 lg:h-9 lg:w-9 lg:text-lg">
                    1
                  </span>
                  인턴십 기회 제공
                </h6>
                <img
                  className="w-full object-cover lg:hidden"
                  src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section13_img1_new_m.png"
                  alt="-"
                />
                <ul className="flex flex-col gap-1 p-4 lg:gap-3 lg:p-0">
                  <li
                    className={`${styles.section13_dot} text-xs leading-normal text-label-assistive lg:text-base`}
                  >
                    교육 수료 후 실제 기업 프로젝트 참여를 통한 경쟁력 있는 포트폴리오 완성
                  </li>
                  <li
                    className={`${styles.section13_dot} text-xs leading-normal text-label-assistive lg:text-base`}
                  >
                    빠른 취업을 위해 한 달간 실무의 정수를 압축하여 경험하고 우수 참가자에게는 취업
                    추천서 발급
                  </li>
                </ul>
              </div>
            </div>
            <div className="flex flex-col items-center justify-center overflow-hidden rounded-lg bg-trueGray-800 lg:flex-row lg:gap-6">
              <img
                className="hidden w-1/2 max-w-[604px] object-cover lg:inline-block"
                src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section13_img2_new_pc.png"
                alt="-"
              />
              <div className="flex flex-1 flex-col lg:mr-6 lg:gap-3 lg:p-6">
                <h6 className="flex flex-row items-center gap-2 p-4 pb-[14px] text-lg font-bold text-white lg:gap-[18px] lg:border-b lg:border-[#A3A3A3] lg:p-0 lg:pb-3 lg:text-2xl">
                  <span className="flex h-6 w-6 items-center justify-center rounded bg-[rgba(255,119,16,0.1)] text-xs font-bold text-yellow-450 lg:h-9 lg:w-9 lg:text-lg">
                    2
                  </span>
                  ICT/IoT 솔루션 전문 기업, <br className="block lg:hidden" />
                  취업 서류 면제 혜택
                </h6>
                <img
                  className="w-full object-cover lg:hidden"
                  src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section13_img2_new_m.png"
                  alt="-"
                />
                <ul className="flex flex-col gap-1 p-4 lg:gap-3 lg:p-0">
                  <li
                    className={`${styles.section13_dot} text-xs leading-normal text-label-assistive lg:text-base`}
                  >
                    우수 수료생에게 국내 IT 솔루션 기업의 서류 면제 및 면접 기회 제공
                  </li>
                </ul>
              </div>
            </div>
            <div className="flex flex-col items-center justify-center overflow-hidden rounded-lg bg-trueGray-800 lg:flex-row lg:gap-6">
              <img
                className="hidden w-1/2 max-w-[604px] object-cover lg:inline-block"
                src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section13_img3_new_pc.png"
                alt="-"
              />
              <div className="flex flex-1 flex-col lg:mr-6 lg:gap-3 lg:p-6">
                <h6 className="flex flex-row items-center gap-2 p-4 pb-[14px] text-lg font-bold text-white lg:gap-[18px] lg:border-b lg:border-[#A3A3A3] lg:p-0 lg:pb-3 lg:text-2xl">
                  <span className="flex h-6 w-6 items-center justify-center rounded bg-[rgba(255,119,16,0.1)] text-xs font-bold text-yellow-450 lg:h-9 lg:w-9 lg:text-lg">
                    3
                  </span>
                  <div className="flex flex-col lg:flex-row lg:items-end">
                    <span className="mr-1.5 text-lg font-bold text-white lg:text-2xl">
                      취업 스펙업 키트 제공
                    </span>
                    <span className="pb-0.5 text-xs text-white lg:pb-0 lg:text-lg lg:font-semibold">
                      *지원 완료 선착순 혜택
                    </span>
                  </div>
                </h6>
                <img
                  className="w-full object-cover lg:hidden"
                  src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section13_img3_new_m.png"
                  alt="-"
                />
                <ul className="flex flex-col gap-1 p-4 lg:gap-3 lg:p-0">
                  <li
                    className={`${styles.section13_dot} text-xs leading-normal text-label-assistive lg:text-base`}
                  >
                    채용 담당자의 노하우를 아낌 없이 담은 취업 준비 로드맵 특강 제공
                  </li>
                  <li
                    className={`${styles.section13_dot} text-xs leading-normal text-label-assistive lg:text-base`}
                  >
                    코딩테스트 대비를 위한 &#60;대기업 출제 유형 그대로 알려주는 코딩테스트 기출
                    문제 풀이&#62; VOD 강의 제공
                  </li>
                </ul>
              </div>
            </div>
            <div className="flex flex-col items-center justify-center overflow-hidden rounded-lg bg-trueGray-800 lg:flex-row lg:gap-6">
              <img
                className="hidden w-1/2 max-w-[604px] object-cover lg:inline-block"
                src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section13_img.gif"
                alt="-"
              />
              <div className="flex flex-1 flex-col lg:mr-6 lg:gap-3 lg:p-6">
                <h6 className="flex flex-row items-center p-4 pb-[14px] lg:border-b lg:border-[#A3A3A3] lg:p-0 lg:pb-3">
                  <span className="mr-2 flex h-6 w-6 items-center justify-center rounded bg-[rgba(255,119,16,0.1)] text-xs font-bold text-yellow-450 lg:mr-[18px] lg:h-9 lg:w-9 lg:text-lg">
                    4
                  </span>
                  <div className="flex flex-col lg:flex-row lg:items-end">
                    <span className="mr-1.5 text-lg font-bold text-white lg:text-2xl">
                      프리러닝 VOD 강의 제공
                    </span>
                    <span className="pb-0.5 text-xs text-white lg:pb-0 lg:text-lg lg:font-semibold">
                      *지원 완료 선착순 혜택
                    </span>
                  </div>
                </h6>
                <img
                  className="w-full object-cover lg:hidden"
                  src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section13_img.gif"
                  alt="-"
                />
                <ul className="flex flex-col gap-1 p-4 lg:gap-3 lg:p-0">
                  <li
                    className={`${styles.section13_dot} text-xs leading-normal text-label-assistive lg:text-base`}
                  >
                    교육 시작에 앞서 기본 개념을 익힐 수 있는 UXUI 및 개발 기초 VOD 강의 제공
                  </li>
                </ul>
              </div>
            </div>
            <div className="flex flex-col items-center justify-center overflow-hidden rounded-lg bg-trueGray-800 lg:flex-row lg:gap-6">
              <img
                className="hidden w-1/2 max-w-[604px] object-cover lg:inline-block"
                src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section13_img3_pc.png"
                alt="-"
              />
              <div className="flex flex-1 flex-col lg:mr-6 lg:gap-3 lg:p-6">
                <h6 className="flex flex-row items-center gap-2 p-4 pb-[14px] text-lg font-bold text-white lg:gap-[18px] lg:border-b lg:border-[#A3A3A3] lg:p-0 lg:pb-3 lg:text-2xl">
                  <span className="flex h-6 w-6 items-center justify-center rounded bg-[rgba(255,119,16,0.1)] text-xs font-bold text-yellow-450 lg:h-9 lg:w-9 lg:text-lg">
                    5
                  </span>
                  실무 경쟁력을 어필하는 <br className="block lg:hidden" />타 직군 협업 기회
                </h6>
                <img
                  className="w-full object-cover lg:hidden"
                  src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section13_img3_m.png"
                  alt="-"
                />
                <ul className="flex flex-col gap-1 p-4 lg:gap-3 lg:p-0">
                  <li
                    className={`${styles.section13_dot} text-xs leading-normal text-label-assistive lg:text-base`}
                  >
                    UXUI 디자이너 등 다양한 직군과의 협업을 통한 실무 경험 및 포트폴리오 강화
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className={`${styles.curriculum_accordion_wrap} ${styles.curriculum_accordion_wrap_shortver} hidden flex-row overflow-hidden rounded-lg bg-trueGray-800 lg:mt-6 lg:flex`}
          >
            <ProgramTab detailList={programDetailList} />
          </div>

          <ul
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className={`${styles.curriculum_accordion_wrap} mt-10 flex flex-col overflow-hidden rounded-lg bg-trueGray-800 pb-4 lg:hidden`}
          >
            <h6 className="flex flex-row items-center gap-2 p-4 pb-[15px] text-lg font-bold text-white lg:hidden">
              <span className="flex h-6 w-6 items-center justify-center rounded bg-[rgba(255,119,16,0.1)] text-xs font-bold text-yellow-450 lg:h-9 lg:w-9 lg:text-lg">
                6
              </span>
              3단계 취업 지원 프로그램
            </h6>
            {programDetailList.map((detail, idx) => (
              <ProgramAccordion contents={detail} key={detail.title} idx={idx} />
            ))}
          </ul>

          <div className="mt-10 text-center text-xs font-semibold text-label-assistive lg:mt-16 lg:text-base lg:font-normal">
            * 교육생 훈련 상황 및 회사 사정에 따라 지원 내용이 <br className="block lg:hidden" />
            변동 될 수 있습니다.
          </div>
        </div>
      </section>

      {/* Section12_준비반 */}
      <section className="bg-gray-900 py-20 lg:pb-40 lg:pt-36">
        <div className="mx-auto w-full max-w-7xl px-4 lg:px-6">
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="mb-10 flex flex-col items-center justify-center gap-2 lg:mb-16 lg:gap-[18px]"
          >
            <p className="text-sm font-bold text-yellow-450 lg:text-lg">코딩테스트 준비반</p>
            <h4 className="text-center text-xl font-bold leading-snug text-white lg:text-4xl lg:leading-[1.4]">
              코딩테스트 완벽 대비
            </h4>
            <p className="text-center text-sm leading-normal text-label-assistive lg:text-lg">
              정규 교육 시간 외 대기업 현직자와 함께 철저히 단련하여
              <br />
              개발자 취업을 완벽하게 준비해요.
            </p>
          </div>

          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
          >
            <video
              className="w-full overflow-hidden rounded-lg"
              muted
              autoPlay
              playsInline
              loop
              controls
            >
              <source
                src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section12_video.mp4"
                type="video/mp4"
              ></source>
            </video>
          </div>

          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className={`${styles.curriculum_accordion_wrap} hidden flex-row overflow-hidden rounded-lg bg-trueGray-800 lg:mt-12 lg:flex`}
          >
            <ProgramTab detailList={prepareFirstDetailList} />
          </div>

          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className={`${styles.curriculum_accordion_wrap} ${styles.curriculum_accordion_wrap_shortver} hidden flex-row overflow-hidden rounded-lg bg-trueGray-800 lg:mt-12 lg:flex`}
          >
            <ProgramTab detailList={prepareSecondDetailList} />
          </div>

          <ul
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className={`${styles.curriculum_accordion_wrap} ${styles.no_dots} mt-10 flex flex-col overflow-hidden rounded-lg bg-trueGray-800 pb-4 lg:hidden`}
          >
            <h6 className="flex flex-row items-center gap-2 p-4 pb-[22px] text-lg font-bold text-white lg:hidden">
              코딩테스트반 과정
            </h6>
            {prepareFirstDetailList.map((detail, idx) => (
              <ProgramAccordion contents={detail} key={detail.title} idx={idx} />
            ))}
          </ul>

          <ul
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className={`${styles.curriculum_accordion_wrap} mt-10 flex flex-col overflow-hidden rounded-lg bg-trueGray-800 pb-4 lg:hidden`}
          >
            <h6 className="flex flex-row items-center gap-2 p-4 pb-[22px] text-lg font-bold text-white lg:hidden">
              코딩테스트반 수업 구성
            </h6>
            {prepareSecondDetailList.map((detail, idx) => (
              <ProgramAccordion contents={detail} key={detail.title} idx={idx} />
            ))}
          </ul>
        </div>
      </section>

      {/* Section14_수료생 후기 */}
      <section className="bg-trueGray-800 py-20 lg:py-40 lg:pt-36">
        <div className="mx-auto w-full max-w-7xl px-4 lg:px-6">
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="mb-12 flex flex-col items-center justify-center gap-2 lg:mb-28 lg:gap-4"
          >
            <p className="text-sm font-bold text-yellow-450 lg:text-lg">수료생 후기</p>
            <h4 className="text-center text-xl font-bold leading-snug text-white lg:text-4xl lg:leading-[1.4]">
              수료생 후기 모음
            </h4>
          </div>
        </div>

        <div
          data-aos-once="true"
          data-aos="fade-up"
          data-aos-easing="ease"
          data-aos-duration="800"
          data-aos-delay="600"
          className={`${styles.section14_slider}`}
        >
          <ReviewSliderItem contents={reviewList} />
        </div>

        <div className="mt-10 text-center text-xs font-semibold text-label-assistive lg:mt-[84px] lg:text-base lg:font-normal">
          * 고용24 안드로이드 개발 부트캠프 수료생의 실제 후기를 <br className="block lg:hidden" />
          발췌하였습니다.
        </div>
      </section>

      {/* Section11_사전설명회 */}
      <section className="bg-[#FFF9F5] py-20 lg:pb-40 lg:pt-36">
        {isAfterEarlySessionDate ? (
          <div className="mx-auto w-full max-w-7xl px-4 lg:px-6">
            <div
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="300"
              className="mb-10 flex flex-col items-center justify-center gap-2 lg:mb-16 lg:gap-4"
            >
              <p className="text-sm font-bold text-yellow-450 lg:text-lg">사전설명회</p>
              <h4 className="text-center text-2xl font-bold text-label-normal lg:text-4xl">
                사전설명회 다시보기
              </h4>
              <p className="text-center text-sm leading-normal text-label-normal lg:text-lg">
                Android 개발 부트캠프 시작 전 궁금한 점이 많으시죠?
                <br />
                실시간 라이브로 진행된 사전설명회를 통해 해결해 보세요!
              </p>
            </div>
            <div
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="600"
              className="flex flex-col"
            >
              <div
                className="h-auto overflow-hidden"
                style={{
                  position: 'relative',
                  paddingTop: '56.25%',
                }}
              >
                <ReactPlayer
                  alt="멋쟁이사자처럼 사전설명회 LIVE"
                  url="https://youtube.com/live/0S7e19cWdDs?feature=share"
                  controls={true}
                  width="100%"
                  height="100%"
                  muted
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                  }}
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="mx-auto w-full max-w-7xl px-4 lg:flex lg:flex-row-reverse lg:items-center lg:justify-between lg:gap-16 lg:px-6">
            <div
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="600"
            >
              <div className="mb-10 flex flex-col items-center justify-center gap-2 lg:mb-3 lg:max-w-[459px] lg:items-start lg:gap-0">
                <p className="text-sm font-bold text-yellow-450 lg:mb-2.5 lg:text-lg">사전설명회</p>
                <h4 className="text-center text-2xl font-bold leading-tight text-label-normal lg:mb-3 lg:text-left lg:text-4xl">
                  강사님의 실험실에서 Flutter
                  <br />
                  시장과 취업 트렌드 단독 공개!
                </h4>
                <p className="text-center text-sm leading-normal text-label-normal lg:mb-2 lg:text-left lg:text-lg">
                  안드로이드 개발 1세대, 강성윤 강사님과 함께 <br className="block lg:hidden" />
                  Flutter 시장과 <br className="hidden lg:block" />앱 개발자 취업 트렌드에 대해
                  이야기 <br className="block lg:hidden" />
                  나누고 질의응답까지 할 수 있는 시간! <br className="block lg:hidden" />
                  지금 바로 사전설명회 신청하고 놓치지 마세요.
                </p>
                <p className="text-center text-sm font-bold leading-normal text-yellow-450 lg:text-left lg:text-lg">
                  일정 : 2025년 2월 4일(화), 오후 6시
                  <br />
                  장소 : Youtube 라이브 스트리밍
                </p>
              </div>
              <div className="flex w-full flex-col">
                <div className="w-full overflow-hidden rounded lg:hidden">
                  <img
                    src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section11_img1.gif"
                    className="h-full w-full object-contain"
                    alt="*참고용 사전설명회 진행 모습"
                  />
                </div>
                <Link
                  href="https://likelion2.typeform.com/kdtaos04"
                  target="_blank"
                  className="mt-10 flex w-full items-center justify-center gap-2 rounded-lg bg-yellow-450 py-4 text-sm font-bold text-white lg:mt-0 lg:max-w-[395px] lg:gap-2.5 lg:py-5 lg:text-lg"
                >
                  사전설명회 신청하기
                  <img
                    className="h-4 w-4 lg:h-[22px] lg:w-[22px]"
                    src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-13th/pre-orientation_icon.png"
                    alt="사전설명회"
                  />
                </Link>
              </div>
            </div>
            <div
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="300"
              className="hidden h-[358px] overflow-hidden rounded-lg lg:inline-block"
            >
              <img
                src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-aos-4th/section11_img1.gif"
                className="h-full w-full object-contain"
                alt="*참고용 사전설명회 진행 모습"
              />
            </div>
          </div>
        )}
      </section>

      {/* Section15_교육혜택 */}
      <section className="bg-[#333333] py-20 lg:py-40 lg:pt-36">
        <div className="mx-auto w-full max-w-7xl px-4 lg:px-6">
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="mb-12 flex flex-col items-center justify-center gap-2 lg:mb-16 lg:gap-4"
          >
            <p className="text-sm font-bold text-yellow-450 lg:text-lg">교육 혜택</p>
            <h4 className="text-center text-xl font-bold leading-snug text-white lg:text-4xl lg:leading-[1.4]">
              오직 뜨거운 열정만 품고 오세요
            </h4>
            <p className="text-center text-sm leading-normal text-label-assistive lg:text-lg">
              나머지는 멋쟁이사자처럼에서 모두 지원해 드릴게요.
            </p>
          </div>
        </div>

        <div
          data-aos-once="true"
          data-aos="fade-up"
          data-aos-easing="ease"
          data-aos-duration="800"
          data-aos-delay="600"
          className={`${styles.benefit_slider}`}
        >
          <BenefitSliderItem contents={benefitSlideList} />
        </div>
      </section>

      <section id="condition" className="bg-[#FFF2E9] py-20 lg:pb-40 lg:pt-36">
        <div className="mx-auto flex w-full max-w-7xl flex-col gap-20 px-4 lg:mx-auto lg:flex-row lg:gap-6 lg:px-6">
          <div className="w-full lg:w-auto lg:flex-1">
            <div
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="300"
              className="mb-6 lg:mb-8"
            >
              <h4 className="text-center text-xl font-bold text-label-normal lg:text-left lg:text-3xl">
                지원 및 선발 안내
              </h4>
            </div>

            <div
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="600"
              className="mb-3 rounded-lg bg-white px-4 py-3 lg:hidden"
            >
              <div className="flex flex-col gap-2">
                <h6 className="w-full text-sm font-semibold leading-normal text-yellow-450">
                  모집 기간
                </h6>
                <p className="w-full text-sm leading-normal text-label-normal">
                  2025년 1월 15일(수) 오후 2시 ~ <br />
                  2025년 3월 10일(월) 오후 11시
                </p>
              </div>
            </div>

            <ul
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="600"
              className="flex flex-col gap-[14px] rounded-lg bg-white px-4 py-3 lg:min-h-[211px] lg:gap-0 lg:px-6 lg:py-5"
            >
              <li className="hidden flex-col items-center justify-center gap-2 border-b border-[#E0DFDE] pb-3 lg:flex lg:flex-row lg:gap-10">
                <h6 className="w-full text-sm font-semibold leading-normal text-yellow-450 lg:w-[90px] lg:shrink-0 lg:text-base lg:font-bold">
                  모집 기간
                </h6>
                <p className="whitespace-pre-line text-sm text-label-normal lg:flex-1 lg:whitespace-normal lg:text-base">
                  2025년 1월 15일(수) 오후 2시 ~ 2025년 3월 10일(월) 오후 11시
                </p>
              </li>
              <li className="flex flex-col items-center justify-center gap-2 lg:flex-row lg:items-start lg:gap-10 lg:py-3 lg:pb-3">
                <h6 className="w-full shrink-0 text-sm font-semibold leading-normal text-yellow-450 lg:w-[90px] lg:text-base lg:font-bold">
                  합격자 발표일
                </h6>
                <div className="flex w-full flex-col">
                  <p className="w-full whitespace-pre-line text-sm text-label-normal lg:whitespace-normal lg:text-base">
                    지원서 제출 후 7일 이내 발표(영업일 기준)
                  </p>
                </div>
              </li>
            </ul>
          </div>

          <div className="w-full lg:w-auto lg:flex-1">
            <div
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="300"
              className="mb-6 lg:mb-8"
            >
              <h4 className="text-center text-xl font-bold text-label-normal lg:text-left lg:text-3xl">
                교육 일정 안내
              </h4>
            </div>

            <ul
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="600"
              className="rounded-lg bg-white px-5 py-4 lg:px-6 lg:py-5"
            >
              {EduScheduleList.map(edu => (
                <li
                  className="flex flex-row items-center justify-center gap-2 border-b-[0.5px] border-[#E0DFDE] py-2 first-of-type:pt-0 last-of-type:border-0 last-of-type:pb-0 lg:gap-8 lg:py-3"
                  key={edu.title}
                >
                  <h6 className="w-[63px] shrink-0 text-sm font-semibold leading-normal text-yellow-450 lg:w-[60px] lg:text-base lg:font-bold">
                    {edu.title}
                  </h6>
                  <p className="flex-1 whitespace-pre-line text-sm text-label-normal lg:whitespace-normal lg:text-base">
                    {edu.content}
                  </p>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div
          data-aos-once="true"
          data-aos="fade-up"
          data-aos-easing="ease"
          data-aos-duration="800"
          data-aos-delay="600"
          className="mx-auto mt-8 w-full max-w-7xl px-4 lg:mt-[30px] lg:px-6"
        >
          <div className="flex flex-col">
            <h6 className="mb-2 text-center text-xs font-semibold text-label-normal lg:text-left lg:text-base">
              * 참고사항
            </h6>
            <p
              className={`${styles.condition_outer_dot} w-full text-xs text-label-normal lg:text-base`}
            >
              국민내일배움카드로 K-Digital Training 과정에 참여할 수 있는 분만 수강 가능합니다.
            </p>
            <p
              className={`${styles.condition_outer_dot} w-full text-xs text-label-normal lg:text-base`}
            >
              매달 출석률에 따라 훈련장려금이 차등 지급됩니다.
            </p>
          </div>
        </div>
      </section>

      <section className="bg-white pb-[120px] pt-20 lg:py-[120px]">
        <div
          data-aos-once="true"
          data-aos="fade-up"
          data-aos-easing="ease"
          data-aos-duration="800"
          data-aos-delay="300"
          className="mx-auto w-full max-w-7xl px-4 lg:px-6"
        >
          <h4 className="mb-4 text-center font-bold text-trueGray-800 lg:mb-6 lg:text-left lg:text-4xl">
            자주 묻는 질문
          </h4>
          <ul
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="mx-auto mb-10 flex max-w-[324px] flex-wrap items-center justify-center gap-1.5 lg:mb-16 lg:max-w-none lg:flex-nowrap lg:justify-start lg:gap-2"
          >
            {bootCampFaqTabList.map(tabItem => {
              const isActive = tabItem.value === faqTab
              return (
                <li
                  className={`${
                    isActive
                      ? 'bg-yellow-450 text-white'
                      : 'border border-normal bg-white text-gray-400'
                  } cursor-pointer rounded-full px-5 py-1.5 text-xs font-bold lg:px-6 lg:py-2 lg:text-sm`}
                  onClick={() => onClickFaqTab(tabItem.value)}
                  key={tabItem.value}
                >
                  {tabItem.label}
                </li>
              )
            })}
          </ul>
          <ul
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className="mx-auto flex flex-col"
          >
            {faqList.map(faq => (
              <li
                className={`${styles.faqItem} border-b border-[#E5E5E5] py-4 first-of-type:pt-0 last-of-type:border-0 last-of-type:pb-0 lg:py-6`}
                key={faq.question}
              >
                <details className="group overflow-hidden">
                  <summary className="cursor-pointer list-none group-open:pb-1 lg:group-open:pb-2">
                    <div className="flex w-full items-center justify-between gap-4">
                      <div>
                        <p
                          className={`${styles.faq_item_title} text-sm font-semibold text-trueGray-800 lg:text-lg`}
                        >
                          {faq.question}
                        </p>
                      </div>
                      <ChevronDownIcon className="w-4 shrink-0 text-gray-500 group-open:rotate-180 lg:w-6" />
                    </div>
                  </summary>
                  <div className="pl-5 lg:pl-[22px]">
                    <div className="whitespace-pre-wrap text-sm leading-normal text-gray-500 lg:text-base">
                      {faq.answer && (
                        <span className="max-w-full">
                          {faq.answer}
                          {faq.externalUrl1 && (
                            <>
                              {' '}
                              자세한 발급 과정은 아래 링크를 통해 확인 가능합니다.
                              <br />-{' '}
                              <Link href={faq.externalUrl1} target="_blank" className="underline">
                                {' '}
                                {faq.urlName1}
                              </Link>
                              {faq.secondAnswer}
                            </>
                          )}
                          {faq.externalUrl2 && (
                            <>
                              <br />-{' '}
                              <Link href={faq.externalUrl2} target="_blank" className="underline">
                                {' '}
                                {faq.urlName2}
                              </Link>
                            </>
                          )}
                        </span>
                      )}
                      {faq.answerList &&
                        faq.answerList.map(el => (
                          <p key={el} className="text-sm text-gray-500 lg:text-base">
                            {el}
                          </p>
                        ))}
                    </div>
                  </div>
                </details>
              </li>
            ))}
          </ul>
          <div className="mt-10 flex flex-col items-start justify-between gap-3 rounded-md bg-[#FFF3EB] p-3 lg:mt-16 lg:flex-row lg:items-center lg:rounded-lg lg:p-10">
            <p className="flex-1 text-left text-base font-semibold text-label-normal lg:text-lg lg:font-bold">
              더 궁금한 점이 있다면 언제든지 교육 매니저에게 <br className="block lg:hidden" />
              물어보세요!
            </p>
            <div className="flex w-full flex-row gap-1.5 lg:w-auto lg:gap-2.5">
              <Link
                href="https://likelion.channel.io/workflows/64782"
                target="_blank"
                className="flex h-9 flex-1 flex-row items-center justify-center gap-1.5 rounded bg-white px-3 text-base font-bold text-yellow-450 lg:h-[50px] lg:w-[206px] lg:gap-2 lg:rounded-lg lg:text-lg"
              >
                1:1 문의하기
                <img
                  src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-13th/faq_icon_btn.png"
                  className="h-4 w-4 shrink-0 object-contain lg:h-[18px] lg:w-[18px]"
                  alt="1:1 문의하기"
                />
              </Link>
              <div
                className="flex h-9 w-9 shrink-0 items-center justify-center rounded bg-yellow-450 lg:h-[50px] lg:w-[50px] lg:rounded-lg"
                onClick={() => copyUrlShare('https://bootcamp.likelion.net/school/kdt-aos-4th')}
              >
                <img
                  src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-13th/faq_icon_share.png"
                  className="h-4 w-4 shrink-0 object-contain lg:h-6 lg:w-6"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default AOSKlass4th
